import { render, staticRenderFns } from "./ApplicationNotification.vue?vue&type=template&id=4686d2d8"
import script from "./ApplicationNotification.vue?vue&type=script&lang=js"
export * from "./ApplicationNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports